<app-card
  [title]="'global.overview'|translate"
  [cardOptionBtnValue]="'doctrine.language.add'|translate "
  [cardOptionBtnIcon]="'feather icon-plus'"
  [cardOptionBtn]="true"
  [cardRouterLink]="'/back-office/localization/languages/add'"
>
  <app-grid [grid]="grid" ></app-grid>
</app-card>
